import React from 'react';

import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface BestOfFiltersProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  sortBy: string;
  setSortBy: (value: 'rank' | 'rating' | 'reviews') => void;
  selectedSubtype: string;
  setSelectedSubtype: (value: string) => void;
  subtypes: string[];
}

export default function BestOfFilters({
  searchTerm,
  setSearchTerm,
  sortBy,
  setSortBy,
  selectedSubtype,
  setSelectedSubtype,
  subtypes
}: BestOfFiltersProps) {
  return (
    <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
      <Input
        type="text"
        placeholder="Search places..."
        value={searchTerm}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value)}
        className="max-w-xs"
      />
      <Select onValueChange={(value: 'rank' | 'rating' | 'reviews') => setSortBy(value)} value={sortBy}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          {['rank', 'rating', 'reviews'].map((value) => (
            <SelectItem key={value} value={value}>Sort by {value.charAt(0).toUpperCase() + value.slice(1)}</SelectItem>
          ))}
        </SelectContent>
      </Select>
      <Select onValueChange={(value: string) => setSelectedSubtype(value)} value={selectedSubtype}>
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Filter by subcategory" />
        </SelectTrigger>
        <SelectContent>
          {subtypes.map((subtype) => (
            <SelectItem key={subtype} value={subtype}>{subtype}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}